import translationEN from "@/locales/en/translation.json";
import translationZH from "@/locales/zh/translation.json";

const i18nResource: Record<string, any> = {
  en: {
    translation: translationEN,
  },
  zh: {
    translation: translationZH,
  },
};

export default i18nResource;
